module.exports = __webpack_public_path__ + "img/result-detail-output-inleft03.e70744c1.svg";